import soundtrack from "../assets/sounds/music/future-technology.mp3";
import complete from "../assets/sounds/effects/complete.mp3";
import denied from "../assets/sounds/effects/wrong.mp3";
import confirmation from "../assets/sounds/effects/confirmation.mp3";
import beep from "../assets/sounds/effects/beep.mp3";
import accept from "../assets/sounds/effects/accept.mp3";
import sonar from "../assets/sounds/effects/sonar.mp3";
import thebrain from "../assets/images/bg/the-brain.jpg";
import brain from "../abi/BRAIN.json";
import brainsNFT from "../abi/BRAINS.json";

import business from "../assets/images/business.png";
import healthcare from "../assets/images/healthcare.png";
import education from "../assets/images/education.png";
import agriculture from "../assets/images/agriculture.png";
import energy from "../assets/images/energy.png";
import finance from "../assets/images/finance.png";
import quote from "../assets/images/quote.png";

import body1 from "../assets/images/bot/body/1.png";
import body2 from "../assets/images/bot/body/2.png";
import body3 from "../assets/images/bot/body/3.png";
import body4 from "../assets/images/bot/body/4.png";
import body5 from "../assets/images/bot/body/5.png";
import body6 from "../assets/images/bot/body/6.png";
import body7 from "../assets/images/bot/body/7.png";
import body8 from "../assets/images/bot/body/8.png";
import body9 from "../assets/images/bot/body/9.png";
import body10 from "../assets/images/bot/body/10.png";
import body11 from "../assets/images/bot/body/11.png";
import body12 from "../assets/images/bot/body/12.png";
import glasses0 from "../assets/images/bot/glasses/0.png";
import glasses1 from "../assets/images/bot/glasses/1.png";
import glasses2 from "../assets/images/bot/glasses/2.png";
import glasses3 from "../assets/images/bot/glasses/3.png";
import hat0 from "../assets/images/bot/hat/0.png";
import hat1 from "../assets/images/bot/hat/1.png";
import sticker0 from "../assets/images/bot/sticker/0.png";
import sticker1 from "../assets/images/bot/sticker/1.png";
import sticker2 from "../assets/images/bot/sticker/2.png";
import sticker3 from "../assets/images/bot/sticker/3.png";
import sticker4 from "../assets/images/bot/sticker/4.png";
import sticker5 from "../assets/images/bot/sticker/5.png";
import sticker6 from "../assets/images/bot/sticker/6.png";
import sticker7 from "../assets/images/bot/sticker/7.png";
import sticker8 from "../assets/images/bot/sticker/8.png";
import sticker9 from "../assets/images/bot/sticker/9.png";
import sticker10 from "../assets/images/bot/sticker/10.png";
import sticker11 from "../assets/images/bot/sticker/11.png";
import sticker12 from "../assets/images/bot/sticker/12.png";
import sticker13 from "../assets/images/bot/sticker/13.png";
import sticker14 from "../assets/images/bot/sticker/14.png";
import sticker15 from "../assets/images/bot/sticker/15.png";

import outlay_insight from "../assets/images/bg/outlay_insight.png";
import outlay_insight_mobile from "../assets/images/bg/outlay_insight_mobile.png";
import outlay_contacts from "../assets/images/bg/outlay_contacts.png";
import outlay_contacts_mobile from "../assets/images/bg/outlay_contacts_mobile.png";
import outlay_advice from "../assets/images/bg/outlay_advice.png";
import outlay_advice_mobile from "../assets/images/bg/outlay_advice_mobile.png";
import outlay_misc from "../assets/images/bg/outlay_misc.png";
import outlay_misc_mobile from "../assets/images/bg/outlay_misc_mobile.png";
import outlay_list from "../assets/images/bg/outlay_list.png";
import outlay_list_mobile from "../assets/images/bg/outlay_list_mobile.png";
import outlay_actions from "../assets/images/bg/outlay_actions.png";
import outlay_actions_mobile from "../assets/images/bg/outlay_actions_mobile.png";

import instruction from "../assets/docs/instructions.json";
import Resources from "../assets/docs/resources.json";

const responseBackground = {
  OutlayInsight: outlay_insight,
  OutlayInsightMobile: outlay_insight_mobile,
  OutlayContacts: outlay_contacts,
  OutlayContactsMobile: outlay_contacts_mobile,
  OutlayAdvice: outlay_advice,
  OutlayAdviceMobile: outlay_advice_mobile,
  OutlayMisc: outlay_misc,
  OutlayMiscMobile: outlay_misc_mobile,
  OutlayList: outlay_list,
  OutlayListMobile: outlay_list_mobile,
  OutlayActions: outlay_actions,
  OutlayActionsMobile: outlay_actions_mobile
};

const instructions = {
  Default: instruction.default,
  Welcome: "Welcome the user to The Brain, which is yourself.",
  Express: instruction.express,
  Disclaimer: instruction.disclaimer,
  Demo: instruction.demo,
}

const resources = {
  Whitelist: Resources.whitelist
}

const landingImages = [
  business,
  healthcare,
  education,
  agriculture,
  energy,
  finance,
  quote,
];

const authors = [
  "Marvin Minsky",
  "Elaine Rich",
  "Allen Newell",
  "Marvin Minsky",
  "Edward Feigenbaum",
  "Joseph Weizenbaum",
  "John McCarthy",
  "Herbert A. Simon",
]

const quotes = [
  "Within a generation... the problem of creating 'artificial intelligence' will substantially be solved.",
  "The study of artificial intelligence is the study of how to make computers do things at which, at the moment, people are better.",
  "To achieve a machine that can think and learn, we must understand not only the mechanics of logic but also the mechanics of thought itself.",
  "You don’t understand anything until you learn it more than one way.",
  "AI is a way of making machines think and learn as people do, but without the constraints of biology.",
  "Machines can decide, but only humans can choose.",
  "In most cases, what is called artificial intelligence is just programming.",
  "We are building tools that will allow us to explore not just what machines can do, but what humans truly are.",
]


const bgmusic = {
    Soundtrack: soundtrack
};

const soundeffects = {
    Complete: complete,
    Denied: denied,
    Confirmation: confirmation,
    Beep: beep,
    Accept: accept,
    Sonar: sonar
};

const contracts = {
    Brain: brain,
    BrainsNFT: brainsNFT
}

const backgroundImages = [
    thebrain
];

const bodies = [
    body1,
    body2,
    body3,
    body4,
    body5,
    body6,
    body7,
    body8,
    body9,
    body10,
    body11,
    body12
  ];
  
  const glasses = [
    glasses0,
    glasses1,
    glasses2,
    glasses3
  ];
  
  const hats = [
    hat0,
    hat1
  ];
  
  const stickers = [
    sticker0,
    sticker1,
    sticker2,
    sticker3,
    sticker4,
    sticker5,
    sticker6, 
    sticker7,
    sticker8,
    sticker9,
    sticker10,
    sticker11,  
    sticker12,
    sticker13,
    sticker14,
    sticker15,
  ];

  
// const ghostBackgroundStyle = (length) => {
//   let ghostBackground, heightMultiplier = Math.ceil(length / 93), height;
//   if (heightMultiplier < 1 ) heightMultiplier = 1;
//   if (length && height) {
//     ghostBackground = {width: '43vw', height: `${length}vh`}
//   } else {
//     ghostBackground = {width: '0vw', height: '0vh'}
//   }
//   return ghostBackground;
// }

export { instructions, responseBackground, landingImages, authors, quotes, 
  resources, bgmusic, soundeffects, backgroundImages, contracts, bodies, 
  glasses, hats, stickers};